import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=1066a48b&scoped=true"
import script from "./QuestionBox.vue?vue&type=script&lang=js"
export * from "./QuestionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066a48b",
  null
  
)

export default component.exports